
            // Dummy implementation of sonner toast library

            // Toast function that does nothing
            const toast = (message, options) => {
              console.log('[Shakespeare Sonner Mock]:', message, options);
              return { id: Math.random().toString(36) };
            };

            // Add common toast methods
            toast.success = (message, options) => {
              console.log('[Shakespeare Sonner Mock] Success:', message, options);
              return { id: Math.random().toString(36) };
            };

            toast.error = (message, options) => {
              console.log('[Shakespeare Sonner Mock] Error:', message, options);
              return { id: Math.random().toString(36) };
            };

            toast.info = (message, options) => {
              console.log('[Shakespeare Sonner Mock] Info:', message, options);
              return { id: Math.random().toString(36) };
            };

            toast.warning = (message, options) => {
              console.log('[Shakespeare Sonner Mock] Warning:', message, options);
              return { id: Math.random().toString(36) };
            };

            toast.loading = (message, options) => {
              console.log('[Shakespeare Sonner Mock] Loading:', message, options);
              return { id: Math.random().toString(36) };
            };

            toast.promise = (promise, options) => {
              console.log('[Shakespeare Sonner Mock] Promise:', promise, options);
              return promise;
            };

            toast.dismiss = (id) => {
              console.log('[Shakespeare Sonner Mock] Dismiss:', id);
            };

            // Toaster component (dummy React component)
            const Toaster = (props) => {
              console.log('[Shakespeare Sonner Mock] Toaster component rendered:', props);
              return null;
            };

            // Export both named and default exports to match sonner API
            export { toast, Toaster };
            export default toast;
          